import { CalendarEventTitleFormatter } from '@beego/ngx-calendar';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class CalendarMobileEventTitleFormatter extends CalendarEventTitleFormatter {
	public monthTooltip(/* event: CalendarEvent */): string {
		return;
	}

	public weekTooltip(/* event: CalendarEvent */): string {
		return;
	}

	public dayTooltip(/* event: CalendarEvent */): string {
		return;
	}
}
